import { FEMA_REGION_META } from 'constants/epaRrtAors';

export type EpaFemaAorSitrep = {
  aorId: string;
  title: string;
  situation: string;
  approvedBy: string;
  timestamp: string;
};

const DEMO_SITREP_TIMESTAMP = '03/30/2025 11:30 AM EDT';

const REGION_SITUATIONS: Record<number, string> = {
  1: 'No tropical-storm cone overlap in New England. Region I is monitoring NHC advisories and standing by to support mutual-aid requests from Regions II and III if Helene tracks farther north.',
  2: 'New York / New Jersey remains outside the current Helene forecast cone. Region II is holding OSC surge capacity and reviewing Superfund readiness checklists in case the track shifts up the Mid-Atlantic.',
  3: 'Mid-Atlantic states are outside the 5-day cone. Region III is coordinating with Region IV on possible northward evacuation of waste and drinking-water mutual aid if Helene intensifies after landfall.',
  4: 'Tropical Storm Helene is tracking through the Gulf toward the Southeast. NPL Superfund sites and public water systems inside the forecast cone are at elevated risk of flooding and loss of power. On-Scene Coordinators are staged for containment checks, and the White House NSC has been notified of likely impact to EPA Gulf resources.',
  5: 'Great Lakes facilities are not in the Helene cone. Region V is monitoring interstate drinking-water interconnections and is prepared to release personnel or equipment if Region IV requests RRT support.',
  6: 'South Central coastal and inland Superfund sites along the western Gulf remain on heightened watch. Region VI is confirming containment integrity and backup power at NPL sites nearest the current Helene forecast cone.',
  7: 'Midwest Region VII has no direct cone overlap. The RRT is in a monitoring posture and has identified OSC teams that can deploy south if Region IV or VI requests reinforcement after landfall.',
  8: 'Mountains and Plains operations are unaffected by Helene. Region VIII is maintaining normal reporting cadence and watching national resource requests from the Gulf and Southeast.',
  9: 'Pacific Southwest has no tropical impact from Helene. Region IX is available for specialty technical assistance (hazardous waste, laboratory analysis) if the national response escalates.',
  10: 'Pacific Northwest remains outside the event. Region X is monitoring the national sitrep and can release incident-management support if EPA Headquarters tasks a multi-region response.',
};

const byAorId = new Map<string, EpaFemaAorSitrep>(
  FEMA_REGION_META.map((meta) => {
    const sitrep: EpaFemaAorSitrep = {
      aorId: meta.id,
      title: `SITREP: FEMA Region ${meta.roman} — Tropical Storm Helene`,
      situation:
        REGION_SITUATIONS[meta.number] ??
        `FEMA Region ${meta.roman} is monitoring Tropical Storm Helene and is prepared to support the national EPA response.`,
      approvedBy: `Regional Administrator, EPA Region ${meta.roman}`,
      timestamp: DEMO_SITREP_TIMESTAMP,
    };
    return [meta.id, sitrep];
  })
);

export function getEpaFemaAorSitrep(
  aorId: string | null | undefined
): EpaFemaAorSitrep | null {
  if (!aorId) return null;
  return byAorId.get(aorId) ?? null;
}
